import { render, staticRenderFns } from "./AiReportList.vue?vue&type=template&id=dedc9096&scoped=true"
import script from "./AiReportList.vue?vue&type=script&lang=js"
export * from "./AiReportList.vue?vue&type=script&lang=js"
import style0 from "./AiReportList.vue?vue&type=style&index=0&id=dedc9096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc9096",
  null
  
)

export default component.exports